import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIService } from '../api/api.service';
import { LoadingState } from '../api/models';
import { toLoadingState } from './scope.service';

@Injectable({
  providedIn: 'root'
})
export class InitiativeResponsiblesService {
  private responsiblesSubject = new BehaviorSubject<LoadingState<string[]>>({ loading: true, data: null });
  public responsibles$ = this.responsiblesSubject.asObservable();

  constructor(private api: APIService) {}

  public loadResponsibles(): void {
    this.responsiblesSubject.next({ loading: true, data: null });
    this.api.get_initiative_responsibles().pipe(
      map((response: any) => response.responsibles || []),
      toLoadingState<string[]>()
    ).subscribe(
      state => {
        this.responsiblesSubject.next(state);
      }
    );
  }

  public getResponsibles(): Observable<LoadingState<string[]>> {
    if (!this.responsiblesSubject.value.data) {
      this.loadResponsibles();
    }
    return this.responsibles$;
  }
} 